import { Role } from "@models";

/**
 * Configuration for xAPI tracking service
 */

export const XAPI_CONFIG = {
  API_ENDPOINT: process.env.LRS_ENDPOINT + "events/",

  ENABLED: process.env.XAPI_ENABLED?.toUpperCase() === "TRUE" || false,

  APPLICATION_NAME: "Dashboard",

  DEFAULT_USER_ROLE: Role.STUDENT.id,

  USERNAME_AUTHENTICATION_METHOD: "username",

  SSO_AUTHENTICATION_METHOD: "sso",
};
